import { Link } from "react-router-dom";
import { MoneyCatalogStatusEnum } from "../../enums/statusEnums";

export const moneyCatalogColumns = [
  {
    field: "id",
    headerName: "ID",
    width: 100,
    renderCell: (params) => (
      <Link to={`/moneyCatalogDetails/${params.row.id}`}>{params.row.id}</Link>
    ),
  },
  { field: "doy", headerName: "ΔΟΥ", width: 100 },
  { field: "mcNo", headerName: "Αριθμός Χρηματικού Καταλόγου", width: 120 },
  {
    field: "mcDate",
    headerName: "Ημερομηνία Χρηματικού Καταλόγου",
    width: 120,
  },
  {
    field: "atb_no",
    headerName: "Αριθμός Τρυπολότυπου Βεβαίωσης (ΑΤΒ)",
    width: 120,
  },
  { field: "atb_date", headerName: "Ημερομηνία ΑΤΒ", width: 100 },
  { field: "total_lines", headerName: "Συνολικά details", width: 100 },
  {
    field: "in_budget",
    headerName: "Σύνολο Εντός Προϋπολογισμού",
    width: 120,
  },
  {
    field: "out_budget",
    headerName: "Σύνολο Εκτός Προϋπολογισμού",
    width: 120,
  },
  {
    field: "total_amount",
    headerName: "Συνολικό Βεβαιωθέν Ποσό",
    width: 120,
  },
  {
    field: "status",
    headerName: "Κατάσταση",
    width: 130,
    valueFormatter: (params) => {
      return MoneyCatalogStatusEnum[params.value] || "-";
    },
  },
  { field: "date_created", headerName: "Ημερομηνίας βεβαίωσης", width: 120 },
];
